const CommonBadge = ({ variant, label, className }) => {
  const getVariantClassName = () => {
    let baseClassName =
      "px-2 py-0.5 rounded-lg text-xs font-medium flex flex-row items-center gap-1 ";

    switch (variant) {
      case "success":
        baseClassName += "bg-[#DCFCE7] border border-[#B9F8CF] text-[#008236] ";
        break;
      case "verified":
        baseClassName +=
          "bg-primary-blur-015 text-primary border border-primary-blur-02 ";
        break;
      case "info":
        baseClassName += "bg-[#DBEAFE] border border-[#00000000] text-primary ";
        break;
      case "warning":
        baseClassName += "bg-[#A65F001A] border border-[#A65F001A] text-[#A65F00] ";
        break;
      case "indigo":
        baseClassName += "bg-[#8200DB1A] border border-[#8200DB1A] text-[#8200DB] ";
        break;
    }

    baseClassName += className ? className : "";
    return baseClassName;
  };

  return <div className={getVariantClassName()}>{label}</div>;
};

export default CommonBadge;
